import * as React from 'react';
import {
  goToHome,
  goToRegister,
  goToForgot,
  goToVerify,
  goToForgotUser,
  registerUrl
} from 'src/utils/navigation';

/* import Alert from './components/Alert'; */
import Button from '../common/Button';
import ToggleSwitch from '../common/ToggleSwitch/ToggleSwitch';
import Alert from './components/Alert';
import Loader from './../common/Loader';

import './SignIn.scss';
import env from 'src/shared/env';

interface ISignInComponentProps {
  login(userId: string, password: string): any;
  signout(): void;
  pending: boolean;
  signinFailed: boolean;
  signinError: string;
  t: any;
  isLoggedIn: boolean;
  shouldSelectAccount: boolean;
  shouldVerify: boolean;
  shouldUpdateInfo: boolean;
  activeAccountCountry: string;
}

interface ISignInComponentState {
  userId: string;
  password: string;
  errorAlert: boolean;
}

class SignInComponent extends React.Component<
  ISignInComponentProps,
  ISignInComponentState
> {
  private enableVerify = parseInt(env.REACT_APP_ENABLE_VERIFY_ACCOUNT, 10);

  constructor(props: any) {
    super(props);

    this.state = {
      userId: '',
      password: '',
      errorAlert: false
    };
  }

  private handleUserId = (event: any) => {
    this.setState({ userId: event.target.value });
  };

  private handlePassword = (event: any) => {
    this.setState({ password: event.target.value });
  };

  private signIn = () => {
    this.setState(
      {
        errorAlert: true
      },
      () => {
        this.props.login(this.state.userId.trim(), this.state.password);
      }
    );
  };

  private handleCloseError = () => {
    this.setState({ errorAlert: false });
  };

  private handleEnterToSubmit = (event: any) => {
    if (event.key === 'Enter') {
      this.signIn();
    }
  };

  private renderHeader = (t: any) => {
    switch (this.props.signinFailed && this.state.errorAlert) {
      default:
      case false:
        return (
          <p className="title h1">
            {env.REACT_APP_BASE_ENVIRONMENT === 'CA'
              ? t('login.sigInToRPCA')
              : t('login.sigInToRPUS')}
          </p>
        );
      case true:
        return (
          <Alert type="error" styleClass="sign-in--error-alert">
            {/* {this.props.signinError} */}
            <span className="sign-in--error-alert--content">
              <i className="rpds rpds-error" />
              <span>
                {t('login.invalidCredentials')}{' '}
                <b> {t('login.invalidUserId')} </b> {t('common.or')}{' '}
                <b>{t('login.invalidEmail')}</b>
              </span>
            </span>
            <i className="rpds rpds-close" onClick={this.handleCloseError} />
          </Alert>
        );
    }
  };

  public render() {
    const { t } = this.props;

    return (
      <div className="sign-in--container">
        {this.props.pending ? <Loader /> : null}
        {/* Component container ^ */}
        {/* Component header v*/}
        <div className="sign-in--header">{this.renderHeader(t)}</div>
        {/* Component content */}
        <div className="sign-in--content">
          <form className="sign-in--form">
            <label className="form--label h4" id="userID" htmlFor="userID">
              {t('login.userIdEmail')}
            </label>
            <input
              className="form--text-input"
              type="text"
              name="userID"
              aria-labelledby="userID"
              value={this.state.userId}
              onChange={this.handleUserId}
              tabIndex={1}
            />
            {/* <a className="form--link" href="javascript:void(0)" onClick={goToForgotUser}>
              {t("login.forgotUserId")}
            </a> */}
            <label className="form--label h4" id="password" htmlFor="password">
              {t('common.password')}:
            </label>
            <input
              className="form--text-input"
              type="password"
              aria-labelledby="password"
              value={this.state.password}
              onChange={this.handlePassword}
              onKeyPress={this.handleEnterToSubmit}
              tabIndex={2}
            />
            <a
              className="form--link password-link"
              href="javascript:void(0)"
              onClick={goToForgot}
            >
              {t('login.forgotPassword')}
            </a>
            <div className="form--sign-and-remember">
              <ToggleSwitch
                enabled={true}
                handleOnButtonChange={() => {
                  console.log('Toggled');
                }}
              />
              <p className="form--label">{t('login.keepMeSignIn')}</p>
            </div>
            <div className="form--sign-in">
              <Button
                buttonClass="primary-button form--login-button"
                label={t('common.signIn')}
                height="48px"
                width="100%"
                action={this.signIn}
              />
            </div>
            <p className="form--label terms-text">
              {t('login.termsAndConditionsText')}
              <a
                className="form--link"
                href={`${env.REACT_APP_BASE_WORDPRESS_URL}terms-and-conditions/`}
              >{` ${t('common.termsAndConditions')}`}</a>
            </p>
          </form>
          {/* Component footer */}
          <span className="sign-in--separator" />
          <div className="sign-in--need-account">
            <p className="title h1">{t('login.needAccount')}</p>
            <p>
              <a
                href={registerUrl()}
                className="register--link"
                onClick={goToRegister}
              >
                {t('login.registerHere')}
              </a>
            </p>
          </div>
        </div>
      </div>
    );
  }
}

export default SignInComponent;
